import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-slate-900 mx-auto"></div>
          <p className="mt-4 text-sm text-slate-600">Chargement...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Redirect manager partners to their dedicated dashboard
  if (user.role === 'partenaire' && user.partner_type === 'manager') {
    if (location.pathname !== '/manager-dashboard' && location.pathname !== '/manager-archives') {
      return <Navigate to="/manager-dashboard" replace />;
    }
  }

  // Redirect other partners to their dedicated dashboard
  if (user.role === 'partenaire' && user.partner_type !== 'manager' && location.pathname !== '/partner-dashboard') {
    return <Navigate to="/partner-dashboard" replace />;
  }

  return children;
};
